export type TImportResponseStatus = {
  action: "new" | "update" | "error" | "";
  success: boolean;
  email: string;
  column: string;
  messages: string[];
  row: number;
};

const MM_SAMPLE_IMPORT_CSV_RESULTS: TImportResponseStatus[] = [
  {
    action: "",
    success: true,
    email: "test+member2@gmail.com",
    column: "",
    messages: [
      "User has been created",
      "Invitation email has been sent",
      "Registration email has been sent",
    ],
    row: 0,
  },
  {
    action: "",
    success: true,
    email: "test+member2@gmail.com",
    column: "",
    messages: [
      "User has been created",
      "Invitation email has been sent",
      "Registration email has been sent",
    ],
    row: 1,
  },
  {
    action: "error",
    success: false,
    email: "test+member3",
    column: "email",
    messages: ["Email must be using SIT account"],
    row: 2,
  },
];

export default MM_SAMPLE_IMPORT_CSV_RESULTS;
